import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Col, Form, message, Modal, Row, Upload } from "antd";
import React, { useEffect } from "react";
import { FormBox, InputBox } from "../../../../components/AntdAddons";
import { validations } from "../../../../config/validations/validations";
import SVGIcon from "../../../../utils/SVGIcon";
import { UploadOutlined } from "@ant-design/icons";

const FormComponent: React.FC<any> = (props) => {
  const {
    visible,
    title,
    close,
    form,
    companies,
    setFileList,
    handleSubmit,
    type,
    editData,
  } = props;

  const handleChange = () => {
    form.validateFields();
  };
  const resetField = () => {
    if (type === "Edit") {
      const allValues = form.getFieldsValue();
      const fieldsToReset = Object.keys(allValues).filter(
        (field) => field !== "company_number"
      );
      // Reset only the selected fields
      form.resetFields(fieldsToReset);
    } else {
      form.resetFields();
    }
  };
  const handleFileChange = ({ fileList }: any) => {
    setFileList(fileList);
    form.setFieldsValue({ file: fileList.length ? fileList : null });
  };
  const beforeUpload = (file: any) => {
    const isLt10MB = file.size / 1024 / 1024 <= 10;
    if (!isLt10MB) {
      message.error(`${file.name} is larger than 10MB`);
      return Upload.LIST_IGNORE;
    }
    const acceptedFileTypes = [
      "application/pdf",
      "application/msword", // DOC
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // DOCX
      "application/vnd.ms-excel", // XLS
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // XLSX
      "text/plain", // TXT
    ];

    if (!acceptedFileTypes.includes(file.type)) {
      message.error(`${file.name} is not a valid file type`);
      return Upload.LIST_IGNORE;
    }
    return isLt10MB;
  };
  useEffect(() => {
    if (type === "Edit") {
      form.setFieldsValue({
        ...editData,
        file: null,
      });
    }
  }, [form, editData, type]);

  return (
    <Modal
      open={visible}
      destroyOnClose
      width={900}
      onCancel={close}
      closeIcon={<FontAwesomeIcon icon={faTimes} />}
      footer={false}
      className="addModal"
      title={title}
    >
      <FormBox
        className="filterForm"
        form={form}
        onFinish={handleSubmit}
        onChange={handleChange}
        validateTrigger={["onBlur"]}
        autoComplete="off"
      >
        <Row gutter={30} align={"top"}>
          <Col xs={24} md={8}>
            <InputBox.Select
              label="Select Company"
              name={"company_name"}
              required
              placeholder="Company"
              options={{
                list: companies ? companies : [],
                valueKey: "value",
                textKey: "label",
              }}
              rules={[validations.required.select()]}
            />
          </Col>
          <Col xs={24} md={8}>
            <InputBox.Text
              name="company_number"
              label="Number"
              maxLength={10}
              disabled={type === "Edit" ? true : false}
              required
              rules={[
                validations.pattern.numeric,
                validations.pattern.whitespace,
                validations.required.text(),
              ]}
            />
          </Col>

          <Col xs={24} md={8}>
            <InputBox.Text
              name="price"
              label="Price"
              step="0.00"
              rules={[
                validations.pattern.decimal(2),
                validations.pattern.whitespace,
              ]}
            />
          </Col>
          <Col xs={24} md={8}>
            <InputBox.Text
              name="gb"
              label="GB"
              rules={[
                validations.pattern.numeric,
                validations.pattern.whitespace,
              ]}
            />
          </Col>
          <Col xs={24} md={8}>
            <InputBox.Text
              name="call"
              label="Call"
              rules={[
                validations.pattern.numeric,
                validations.pattern.whitespace,
              ]}
            />
          </Col>
          <Col xs={24} md={8}>
            <InputBox.Text
              name="sms"
              label="SMS"
              rules={[
                validations.pattern.numeric,
                validations.pattern.whitespace,
              ]}
            />
          </Col>

          <Col xs={24} md={8}>
            <InputBox.Text
              name="name"
              label="Name"
              placeholder="Name"
              rules={[
                validations.pattern.whitespace,
                validations.min.text(3),
                validations.max.text(50),
              ]}
            />
          </Col>
          <Col xs={24} md={8}>
            <InputBox.TextArea
              name="description"
              label="Description"
              placeholder="Description"
              rules={[
                validations.pattern.whitespace,
                validations.min.text(3),
                validations.max.text(100),
              ]}
              rows={2}
            />
          </Col>
          <Col xs={24} md={8}>
            <Form.Item name="file" label="Upload File">
              <Upload
                beforeUpload={beforeUpload}
                maxCount={1}
                onChange={handleFileChange}
                listType="text"
                accept=".pdf,.doc,.docx,.xls,.xlsx,"
              >
                <Button icon={<UploadOutlined />}>Upload File</Button>
              </Upload>
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={30} align={"top"}>
          <Col xs={24} md={12} lg={6}>
            <Button type="primary" htmlType="submit">
              {type === "Edit" ? (
                "Submit"
              ) : (
                <>
                  <SVGIcon icon="add" color="#fff" width={55} /> Add
                </>
              )}
            </Button>
          </Col>
          <Col xs={24} md={12} lg={6}>
            <Button type="default" onClick={() => resetField()}>
              Clear
            </Button>
          </Col>
        </Row>
      </FormBox>
    </Modal>
  );
};

export default FormComponent;
